module.exports = __webpack_public_path__ + "img/br5.99ffa8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br5.jpg
// module id = qrEY
// module chunks = 0